<template>
  <div class="login-layout">
    <div class=login-top>
      <p>{{appName}} <span>{{appVersion}}</span></p>
      <!-- <span>{{siteName}}</span> -->
    </div>
    <div class=login-main>
      <div class="login">
        <div class="login_box">
          <el-form ref="formRef" :model="form" :rules="rules" label-width="70px">
            <el-form-item label="用户名" prop="adminName">
              <el-input v-model="form.adminName" placeholder="请输入用户名" suffix-icon="el-icon-user"></el-input>
            </el-form-item>
            <el-form-item label="密&nbsp;&nbsp;&nbsp;&nbsp;码" prop="password">
              <el-input v-model="form.password" show-password placeholder="请输入用户密码" suffix-icon="el-icon-lock"></el-input>
            </el-form-item>
            <el-form-item label="验证码" prop="vcode">
              <el-input v-model="form.vcode" placeholder="请输入验证码" suffix-icon="el-icon-circle-check" class="vcode" style="width:98px"></el-input>
              <img :src="vcodeImg" alt="看不清?点击更换" onclick="this.src = this.src + '?'" class="vcode" />
            </el-form-item>
            <el-button type="primary" round @click="onLogin">登 录</el-button>
          </el-form>
        </div>
      </div>
    </div>
    <div class=login-footer>
      <img src="~@/assets/img/jdw.png" alt=""> 云南景多维科技有限公司
    </div>
  </div>
</template>

<script>
export default {
  name: 'login',
  data () {
    return {
      appName: '',
      appVersion: '',
      vcodeImg: this.$api.validatecode,
      // xuToken: {
      //   // 获取到的凭证
      //   token: '',
      //   // 凭证有效时间
      //   expires: 0,
      //   // 得到的时间 (秒)
      //   time: 0
      // },
      form: {
        adminName: '',
        password: '',
        vcode: ''
      },
      rules: {
        adminName: [
          { required: true, message: '用户名不能为空', trigger: 'blur' }
          // { min: 6, max: 20, message: '长度在 6 到 20 个字符', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '密码不能为空', trigger: 'blur' }
          // { min: 6, max: 20, message: '长度在 6 到 20 个字符', trigger: 'blur' }
        ],
        vcode: [
          { required: true, message: '验证码不能为空', trigger: 'blur' }
        ]
      }
    }
  },
  mounted () {
    // console.log('process=', process)
    // console.log('process.env.NODE_ENV=', process.env.NODE_ENV)
    // console.log('process.env.VUE_APP_URL11=', process.env.VUE_APP_URL)
    const ui = this.$api.ui
    if (ui !== null) {
      this.appName = ui.appName
      this.appVersion = ui.appVersion
      // this.form.adminName = ui.adminName
    }
  },
  methods: {
    onLogin () {
      this.$refs.formRef.validate(async (valid) => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: 'Loading',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          })
          const { data: ret } = await this.$http.post(this.$api.login, this.form)
          // console.log('ret=', ret)
          if (ret.status === 0) {
            this.$message.success(ret.message)
            // this.xuToken.token = ret.token.token
            // this.xuToken.expires = ret.token.expires
            // this.xuToken.time = Math.ceil(new Date().getTime() / 1000)
            // this.$storage.set('xucmstoken', this.xuToken)
            this.$storage.set('admininfo', ret.data.ui)
            this.$storage.set('xudaqtoken', ret.data.token)
            this.$router.push('/sys/index')
          } else {
            this.$message.error(ret.message)
            this.vcodeImg = this.$api.validatecode + '?' + new Date().getTime()
          }
          loading.close()
        } else {
          this.$message.error('验证没通过。')
          return false
        }
      })
      // if (!this.valid()) {
      //   return
      // }
      // const loading = this.$loading({
      //   lock: true,
      //   text: '正在加载中...',
      //   spinner: 'el-icon-loading',
      //   background: 'rgba(0, 0, 0, 0.7)'
      // })
      // setTimeout(() => {
      //   loading.close()
      //   if (this.uname === '123' && this.upassword === '123') {
      //     // this.$message.success('恭喜你，登录成功。')
      //     this.$router.push('./mlxs')
      //     // window.location.replace('./mlxs')
      //     // window.location.href= ''
      //   } else {
      //     this.$message.error('用户名或是密码错误。')
      //   }
      // }, 2000)
    },
    valid () {
      if (this.uname === '') {
        this.$message('用户名不能为空。')
        return false
      }
      if (this.upassword === '') {
        this.$message('密码不能为空。')
        return false
      }
      if (this.vcode === '') {
        this.$message('验证码不能为空。')
        return false
      }
      return true
    }
  }
}
</script>

<style lang="less" scoped>
  .login-layout {
    width: 100%;
    height: 100%;
    background: url('~@/assets/img/login_bg.jpg') center no-repeat;
  }
  .login-top {
    display:ceil;
    height: 15%;
    padding-top: 5%;
    vertical-align:bottom;
    text-align: center;
    color: #fff;
    font-size: 36px;
    font-weight: bold;
    letter-spacing:8px;
    // border: 1px dashed #618FE7;
    p {
      margin: 10px;
      span{
        font-size: 20px;
        color: #eee;
      }
    }
    span {
      font-size: 30px;
    }
    // display: flex;
    // align-items: center; /*定义body的元素垂直居中*/
    // justify-content: center; /*定义body的里的元素水平居中*/
    // img {
    //   max-width: 100%;
    //   height: auto;
    //   position: relative;
    //   top: 90%;
    //   transform: translate(0, -100%);
    // }
  }
  .login-main {
    height: 65%;
    text-align: center;
    // border: 1px dashed #618FE7;
    .login {
      width: 320px;
      height: 270px;
      margin: 0 auto;
      // border: 1px dashed #618FE7;
      background: url('~@/assets/img/login_box.png') center no-repeat;
      position: relative;
      top: 50%;
      transform: translate(0, -50%);
      .login_box {
        position: relative;
        z-index:10;
        top: 55px;
        left: 30px;
        width: 260px;
        padding-top: 8px;
        //border: 1px dashed #618FE7;
        font-size: 16px;
        color: #000;
        dl {
          margin: 0;
          padding: 6px 0;
          text-align: center;
        }
        .vcode{
          vertical-align:middle;
        }
        .el-input{
          width: 190px;
          font-size: 14px;
        }
        .el-button{
          width: 110px;
          font-size: 14px;
          // padding: 10px;
        }
      }
    }
  }
  .login-footer {
    height: 10%;
    font-size: 16px;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    img {
      width: 40px;
      height: 40px;
      padding-right: 10px;
    }
  }
</style>
